/**
 * tRPC Client Configuration for Results Portal
 * Configures the tRPC client with SSE subscription support
 */

// Force deployment

import {
  createTRPCClient,
  httpLink,
  httpSubscriptionLink,
  splitLink,
} from '@trpc/client';
import type { AppRouter } from '../../../../tiny-ai/src/api/trpc/router';
import {
  getAuthHeaders,
  getStreamingBaseUrl,
  getStreamingEventSourceUrl,
} from './utils';

export const trpc = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      condition(op) {
        return op.type === 'subscription';
      },
      true: httpSubscriptionLink({
        url: () => getStreamingEventSourceUrl(),
        transformer: undefined,
        eventSourceOptions() {
          return { withCredentials: true };
        },
      }),
      false: httpLink({
        url: getStreamingBaseUrl(),
        transformer: undefined,
        headers() {
          return getAuthHeaders();
        },
      }),
    }),
  ],
});
